import React, { useState, useEffect, useRef } from 'react'

import {
    Button, Dialog, Grid, Icon,
    Typography, FormLabel, FormHelperText, FormControl,
    FormGroup, FormControlLabel, Checkbox
} from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import RichTextEditor from 'react-rte';
import { InputBaseField, SelectField, TextareaField } from '../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../Services/APIService';
import { withSnackbar } from "../../../components/Message/Alert";
import useStyles from "./styles";
import { validateEmail, validatePhoneNumber, allowedAttachmentsImages } from '../../../../src/components/Common/Extensions';

import CropDemo from './../components/cropImg/CropExample';
import DialogLoader from '../../../components/Loader/DialogLoader';


function ChangeDocument({ dialogOpenClose, handleClose, handleSuccessClose, record, changeDocumentAction, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(record);
    const [documentPath, setDocumentPath] = useState(changeDocumentAction == 'receiving' ? record.receivingPicturePath : record.identityProof);
    const { showMessage } = props;
    const [errorMessages, setErrorMessages] = useState({});
    const [attachmentImage, setAttachmentImage] = useState({ file: null, fileToSend: null, fileName: null });

    const [fileUrl, setFileUrl] = useState(null);
    const [fieldName, setFieldName] = useState(null);

    const commonAttachments = allowedAttachmentsImages();

    const onSave = async (croppedImage, fieldName) => {

        const name = fieldName.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setAttachmentImage({
            file: croppedImage,
            fileToSend: croppedImage,
            fileName: fieldName.files[0].name
        })

        setTimeout(() => {
            setCropImageDialog(false)
        })
    };


    const [cropImagedialog, setCropImageDialog] = useState(false);


    const openCropImage = () => {
        setCropImageDialog(true)
    }

    const closeCropImage = () => {
        fieldName.value = ""
        setCropImageDialog(false)
    }


    const handleFileChange = (e) => {
        openCropImage()
        const selectedFile = e.target.files[0];
        const url = URL?.createObjectURL(selectedFile);
        setFileUrl(url);
        setFieldName(e.target)
    }



    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setAttachmentImage({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        })
    }


    const inputFile = useRef(null);

    const uploadFile = () => {

        inputFile.current.click();
    };

    const uploadDocument = () => {
        let errorList = [];
        if (!attachmentImage.file) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAttachment: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAttachment: false
            }));
        }
        if (errorList.length < 1) {
            var method = "fdnmcchromicconnect/update";
            const formData = new FormData();

            for (var key in state) {
                if (state[key]
                    && key != "fileToSend"
                    && key != "fileName"
                    && key != "identityFile"
                    && key != "identityName"
                    && key != "receivingFile"
                    && key != "receivingFileName"
                    && key != "encUserID")
                    formData.append(key, state[key]);
            }

            if (changeDocumentAction == 'receiving') {
                formData.append("receivingFile", attachmentImage.fileToSend);
                formData.append("receivingFileName", attachmentImage.fileName);
            } else {
                formData.append("identityFile", attachmentImage.fileToSend);
                formData.append("identityName", attachmentImage.fileName);
            }
            setIsLoading(true);
            PostDataAPI(method, formData, true, "formData").then((result) => {
                setIsLoading(false);
                if (result.success) {
                    if (result.data) {
                        handleSuccessClose("Document updated successfully");
                    }
                    else {
                        showMessage("Error", "Error saving application, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
            })
        }
    }

    const [unixTimestamp, setUnixTimestamp] = useState(0);
    useEffect(() => {
        if (record && record.applicationId > 0) {
            setState(record);
            if (record.updateDate)
                setUnixTimestamp(Math.floor(new Date(record.updateDate).getTime() / 1000));
        }
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>

                {cropImagedialog ?
                    <CropDemo open={openCropImage} onClose={closeCropImage} fieldName={fieldName} src={fileUrl} onSave={onSave}></CropDemo> : ''
                }


                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{record.firstName} - {changeDocumentAction == 'receiving' ? 'Proof Of Delivery' : 'Proof Of Identity'} </Typography>

                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>


                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <Scrollbars autoHeight autoHeightMax={480}>
                        <div className={classes.content}>

                            <Grid container spacing={2}>
                                <Grid item sm={12} md={12} lg={12} xl={12}>


                                    <Grid container spacing={2}>
                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Choose image" size={12} mandatory={true} />

                                                <div className={classes.photoInfo}>
                                                    <input type="file" id="fileUploadField" name="proofOfIdentity" ref={inputFile} className={classes.inputFile} onChange={handleFileChange} accept=".png, .jpg, .jpeg" />

                                                </div>

                                                {errorMessages.errorAttachment && !attachmentImage.file ? (<FormHelperText style={{ color: "red" }} >
                                                    Please select document
                                                </FormHelperText>) : ('')}

                                            </Grid>

                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid item sm={12} md={12} lg={12} xl={12}>

                                    {attachmentImage.file || documentPath ?
                                        <>
                                            <img src={attachmentImage.file ? attachmentImage.file : '.' + documentPath + '?v=' + unixTimestamp} className={classes.previewImg}
                                                id="previewimg"
                                                style={{
                                                    borderColor: 'gray',
                                                    borderWidth: '2px',
                                                    marginTop: '5px',
                                                    width: '100%',
                                                    height: '240.1px',
                                                    objectFit: 'contain',
                                                    objectPosition: 'center',
                                                    borderradius: '15px',
                                                    padding: '5px',
                                                    borderRadius: "5px",

                                                }}
                                                alt="" />
                                        </>
                                        : ''
                                    }

                                </Grid>

                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} onClick={uploadDocument}>Submit</Button>

                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(ChangeDocument);
